import moment from 'moment';
import React from 'react';
import { TextField } from '@material-ui/core';

import { formatDateForDisplay } from '../../Utils/date';

import './InputDateField.scss';


class InputDateField extends React.Component {
  constructor(props) {
    super(props);

    const value = props.value;
    this.state = {
      isValid: true,
      ...this._convertToViewAndEditValues(value)
    };
  }

  _convertToViewAndEditValues(value) {
    let viewValue = '';
    let editValue = '';
    if (value) {
      viewValue = value.toLocaleDateString('en-US', { timeZone: 'UTC' });
      editValue = value.toISOString().slice(0, 10);
    }
    return { viewValue, editValue };
  }

  componentDidUpdate(prevProps) {
    if (this.props.value !== prevProps.value) {
      this.setState(this._convertToViewAndEditValues(this.props.value));
    }
  }

  handleChange = value => {
    this.setState({ editValue: value });
  }

  handleBlur = () => {
    const editValue = this.state.editValue;
    const { onChange, min, max, showError, value } = this.props;

    let returnValue;
    if (editValue === '') {
      returnValue = null;
    }
    else {
      const valueParts = editValue.split('-');
      const valueYear = Number(valueParts[0]);
      const valueMonth = (Number(valueParts[1]) - 1);
      const valueDate = Number(valueParts[2]);

      // This flag can be used instead of manually adding a day as a workaround:
      if (this.props.fixOffByOneIssue) {
        returnValue = new Date(valueYear, valueMonth, valueDate);
      } else {
        // This converts from the user's timezone to UTC, which has been causing off-by-one bugs.
        // Multiple cases of workarounds exist in the codebase for this issue; this code is preserved to prevent breaking those workarounds:
        returnValue = new Date(Date.UTC(valueYear, valueMonth, valueDate));
      }
    }

    if (min) {
      this.setState(this._convertToViewAndEditValues(value))
    }
    // Validates date format
    let regex = /^\d{4}-\d{2}-\d{2}$/
    if (showError && max) {
      if (regex.test(editValue) && moment(editValue).isSameOrBefore(max)) {
        this.setState({ isValid: true, date: '' })
        onChange(returnValue, editValue);
      } else {
        this.setState({
          isValid: !editValue,
          editValue: '',
          date: editValue && formatDateForDisplay(editValue)
        });

        onChange('');
        return;
      }
    } else {
      onChange(returnValue, editValue);
    }
  }

  render() {
    const {
      editMode,
      inputId,
      disabledMode,
      min,
      max,
      showError,
      errorMessage,
    } = this.props;

    const { isValid, editValue, viewValue, date } = this.state

    return (
      <div className="parkchirp--input-date-field">
        {editMode ?
          <>
            <TextField id={inputId}
              type="date"
              value={editValue}
              onChange={event => this.handleChange(event.target.value)}
              onBlur={this.handleBlur}
              disabled={disabledMode}
              min={min}
              max={max}
            />
            {showError && (!editValue && isValid) ? <span className='error'>{errorMessage || 'Provide a valid date'}</span> : date && <span className='error'>{date} is not a valid date</span>}
          </>
          :
          <span>{viewValue}</span>
        }
      </div>
    );
  }
};

export default InputDateField;
